import { render, staticRenderFns } from "./GameOver.vue?vue&type=template&id=5068dd1e&"
import script from "./GameOver.vue?vue&type=script&lang=ts&"
export * from "./GameOver.vue?vue&type=script&lang=ts&"
import style0 from "./GameOver.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports